import { render, staticRenderFns } from "./additionalDataTab.vue?vue&type=template&id=a6037f40&scoped=true&"
import script from "./additionalDataTab.vue?vue&type=script&lang=js&"
export * from "./additionalDataTab.vue?vue&type=script&lang=js&"
import style0 from "./additionalDataTab.vue?vue&type=style&index=0&id=a6037f40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6037f40",
  null
  
)

export default component.exports